<template>
    <div>
        
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <ProductcsText></ProductcsText>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';
import ProductcsText from '@/components/ProductcsText.vue';

export default {
    name: 'ProductsPage',
    components: {
        HeaderPage,
        SlideShow,
        ProductcsText,
        FooterPage
    },
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
</style>